var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgClockOrangeCircle = function SvgClockOrangeCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5.125A9.375 9.375 0 1 0 18.875 9.5 9.385 9.385 0 0 0 9.5.125Zm4.063 13.454a.793.793 0 0 1-1.104.048l-3.875-3.551a.781.781 0 0 1-.256-.576V5.203a.781.781 0 1 1 1.563 0v3.953l3.62 3.319a.781.781 0 0 1 .052 1.105v-.001Z",
    fill: "#F39237"
  })));
};

export default SvgClockOrangeCircle;